import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';
import { makeServer } from '../../tests/js/server'

import AppProvider from 'app/context/AppProvider';
import ApiProvider from 'app/context/ApiProvider';

// Universal Methods
window.containsObject = (obj, array) => {

    var i;

    for (i = 0; i < array.length; i++) {
        if (array[i] === obj) {
            return i;
        }
    }

    return -1;
}

window.containsObjectByKey = (obj, array, x) => {

    var i;

    for (i = 0; i < array.length; i++) {
        if (array[i][x] === obj[x]) {
            return i;
        }
    }

    return -1;
}
window.ucFirst = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

if (process.env.MIX_MOCKING === 'true') {
    makeServer({})
}

const App = (
    <BrowserRouter>
        <MuiPickersUtilsProvider utils={LuxonUtils}>
            <ApiProvider>
                <AppProvider/>
            </ApiProvider>
        </MuiPickersUtilsProvider>
    </BrowserRouter>
)

if (document.getElementById('app')) {
    render(App, document.getElementById('app'));
}
